import { Building } from './building';
import { CheckCircle } from './checkCircle';
import { Cookie } from './cookie';
import { CrownCross } from './crownCross';
import { Cruz } from './cruz';
import { FacebookIcon } from './facebook';
import { Grains } from './grains';
import { HandArrowDown } from './handArrowDown';
import { InstagramIcon } from './instagram';
import { MagnifyingGlass } from './magnifyingGlass';
import { MenuButton } from './menuButton';
import { Person } from './person';
import { XMark } from './xMark';
import { XTwitterIcon } from './xTwitter';
import { InfoCircle } from './infoCircle';
import { Trash } from './trash';
import { Chart } from './chart';
import { GasPump } from './gasPump';
import { Stethoscope } from './stethoscope';
import { Tower } from './tower';
import { Shop } from './shop';
import { WarningShield } from './warningShield';
import { StarShield } from './starShield';
import { Lock } from './lock';

export {
	Building,
	CheckCircle,
	Cookie,
	CrownCross,
	Cruz,
	FacebookIcon,
	Grains,
	HandArrowDown,
	InstagramIcon,
	InfoCircle,
	MagnifyingGlass,
	MenuButton,
	Person,
	XMark,
	XTwitterIcon,
	Trash,
	Chart,
	Shop,
	Tower,
	GasPump,
	Stethoscope,
	WarningShield,
	StarShield,
	Lock,
};
